import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
`;

export const Form = styled.form`
  margin-top: 24px;

  max-width: 900px;
`;

export const Footer = styled.footer`
  margin-top: 24px;
`;
